import React from 'react'
import {FormattedMessage} from 'react-intl';
import Browser from '../../../components/Browser';
import Ticket01 from '../../../assets/icons0/ticket-01.svg';
import CartButton from '../local-cart/cart-button';

const EndpointsHeader = ({serviceByIdOrSlug, localCartState, isLocalCartDeferred, setCartVisibility, showCart, isStem}) => {
    return (
        <div className='padding-top-2rem position-sticky top-0 z-index-1 endpoints-header-container'>
            <div className='padding-bottom-1rem border-bottom-1px-solid display-flex justify-content-space-between align-items-center endpoints-header'>
                <div className='display-flex'>
                    <Ticket01 className='display-block height-1dot5rem color-primary-500 endpoints-header__icon'/>
                    <p className='margin-left-0dot75rem text-lg medium endpoints-header__title'><FormattedMessage defaultMessage='Tickets' /></p>
                </div>
                {showCart && 
                    <Browser fallback={<div className='display-none mw768-display-block min-width-11rem min-height-2dot75rem'></div>}>
                        <CartButton {...{serviceById: serviceByIdOrSlug, localCartState, isLocalCartDeferred, setCartVisibility, isStem}}/>
                    </Browser>
                }
            </div>
        </div>
    )
}

export default React.memo(EndpointsHeader);
